<template>
  <div class="Digital">

    <div class="wrapper">
      <h1>Digital Work.</h1>
  
      <h2>I approach each project as I approach life: with integrity, respect, consideration - and a healthy sense of adventure.</h2>

      <!--
      <div class="recent">Explore select case studies or see <router-link to="/digital/recent">what I've been up</router-link> to recently.</div>
      -->
  
      <!-- Projects -->
      <div class="projects">
        <router-link :to="{ name: 'Hyatt' }" class="project">
          <div class="content">
            <img src="/assets/digital/hyatt-preview.png" srcset="/assets/digital/hyatt-preview.png 565w, /assets/digital/hyatt-preview@2x.png 1130w" sizes="565px" class="preview">
            <img src="/assets/digital/logo-hyatt.svg" class="logo">
            <div class="type">Internal budget allocation platform.</div>
            <div class="bg"></div>
          </div>
        </router-link>
        <router-link :to="{ name: 'Erbium' }" class="project right">
          <div class="content">
            <img src="/assets/digital/erbium-preview.png" srcset="/assets/digital/erbium-preview.png 565w, /assets/digital/erbium-preview@2x.png 1130w" sizes="565px" class="preview">
            <img src="/assets/digital/logo-erbium.svg" class="logo">
            <div class="type">Online event registration platform.</div>
            <div class="bg"></div>
          </div>
        </router-link>
  
        <router-link :to="{ name: 'Cadex' }" class="project">
          <div class="content">
            <img src="/assets/digital/cadex-preview.png" srcset="/assets/digital/cadex-preview.png 565w, /assets/digital/cadex-preview@2x.png 1130w" sizes="565px" class="preview">
            <img src="/assets/digital/logo-cadex.svg" class="logo">
            <div class="type">IoT B2B platform.</div>
            <div class="bg"></div>
          </div>
        </router-link>
        <router-link :to="{ name: 'W2W' }" class="project right">
          <div class="content">
            <img src="/assets/digital/w2w-preview.png" srcset="/assets/digital/w2w-preview.png 565w, /assets/digital/w2w-preview@2x.png 1130w" sizes="565px" class="preview">
            <img src="/assets/digital/logo-w2w.svg" class="logo">
            <div class="type">Job search platform.</div>
            <div class="bg"></div>
          </div>
        </router-link>
  
        <router-link :to="{ name: 'Epicure' }" class="project">
          <div class="content">
            <img src="/assets/digital/epicure-preview.png" srcset="/assets/digital/epicure-preview.png 565w, /assets/digital/epicure-preview@2x.png 1130w" sizes="565px" class="preview">
            <img src="/assets/digital/logo-epicure.svg" class="logo">
            <div class="type">Internal sales platform.</div>
            <div class="bg"></div>
          </div>
        </router-link>
        <router-link :to="{ name: 'MoreProjects' }" class="project right">
          <div class="content">
            <img src="/assets/digital/other-preview.png" srcset="/assets/digital/other-preview.png 565w, /assets/digital/other-preview@2x.png 1130w" sizes="565px" class="preview">
            <div class="logo">More Projects</div>
            <div class="type">Sampling of other digital design.</div>
            <div class="bg"></div>
          </div>
        </router-link>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'

export default {
  name: 'Digital',
  components: {
    Footer
  },
}
</script>

<style lang="scss" scoped>
  .Digital {
    background: #fff;
    padding: 160px 0 0 0;

    & .wrapper {
      @include siteWrapper;
    }

    & h1 {
      margin: 0 0 60px 0;
      text-align: center;
    }
    & h2 {
      margin: 0 auto 40px auto;
      text-align: center;
      max-width: 1000px;

      @media screen and (max-width: 1000px) {
        padding: 0 40px;
      }
      @media screen and (max-width: $breakSmall) {
        padding: 0 20px;
      }
    }

    & .recent {
      margin: 0 auto 80px auto;
      text-align: center;
      font-size: 22px;

      @media screen and (max-width: $breakSmall) {
        font-size: 20px;
      }
    }

    & .projects {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      & .project {
        width: 45%;
        padding-bottom: 30%;
        margin: 0 0 10% 0;
        position: relative;
        background: rgb(0,162,203);
        background: radial-gradient(circle at bottom center, rgba(0,162,203,1) 0%, rgba(22,31,109,1) 100%);
        color: #fff;
        transition: all 300ms;

        & .content {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          overflow: hidden;
          z-index: 5;
          opacity: 0;
          animation: loadContent 500ms 700ms forwards;

          @keyframes loadContent {
            from {opacity: 0;}
            to {opacity: 1;}
          }

          & .preview {
            width: 90%;
            position: absolute;
            left: -40%;
            top: 50%;
            transform: translateY(-50%);
            z-index: 5;
            transition: all 300ms;
          }
          & .logo {
            width: 32%;
            position: absolute;
            right: 10%;
            top: 50%;
            transform: translateY(-50%);
            z-index: 5;
            transition: all 900ms;
            // improve chrome rendering on animation
            will-change: right, left;
            // for passed strings
            @include fontBodyHead;
            font-size: 22px;
            text-transform: uppercase;
            text-align: center;

            @media screen and (max-width: $breakLarge) {
              font-size: 18px;
            }
            @media screen and (max-width: $breakSmall) {
              font-size: 22px;
            }
            @media screen and (max-width: $breakLarge) {
              font-size: 16px;
              line-height: 22px;
            }
            @media screen and (max-width: $breakSmall) {
              font-size: 18px;
              line-height: 26px;
            }
            @media screen and (max-width: $breakHandsetLandscape) {
              font-size: 15px;
              line-height: 20px;
            }
          }
          & .type {
            @include fontBodyHead;
            font-size: 18px;
            line-height: 26px;
            width: 40%;
            text-align: center;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            z-index: 2;
            transition: all 600ms;

          }
          & .bg {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            z-index: 1;
            background: radial-gradient(circle at center center, rgba(0,162,203,1) 0%, rgba(22,31,109,1) 100%);
            opacity: 0;
            transition: all 300ms;
          }
        }
        &:hover {
          color: #fff;

          & .content {
            & .preview {
              left: -50%;
            }
            & .logo {
              right: -40%;
            }
            & .type {
              left: 48%;
            }
            & .bg {
              opacity: 1;
            }
          }
        }
        // right version
        &.right {

          & .content {

            & .preview {
              left: auto;
              right: -40%;
            }
            & .logo {
              right: auto;
              left: 10%;
            }
            & .type {
              left: auto;
              right: 0;
            }
          }
          &:hover {

            & .content {
              & .preview {
                left: auto;
                right: -50%;
              }
              & .logo {
                right: auto;
                left: -40%;
              }
              & .type {
                left: auto;
                right: 48%;
              }
            }
          }
        }
      }

      @media screen and (max-width: $breakSmall) {
        justify-content: space-around;

        & .project {
          width: 100%;
          padding-bottom: 60%;
          margin: 0 0 20% 0;

          &:hover {
            & .content {
              & .preview {
                left: -40%;
              }
              & .logo {
                right: 10%;
              }
              & .type {
                left: 0;
              }
            }
          }
          &.right {
            &:hover {
              & .content {
                & .preview {
                  right: -40%;
                }
                & .logo {
                  left: 10%;
                }
                & .type {
                  right: 0;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
